import { useState } from 'react';
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  Layer,
  MessageBar,
  MessageBarType,
  PrimaryButton,
} from '@fluentui/react';
import { useAppUpdateCheck } from '@hooks/useAppUpdateCheck';

function reloadApp() {
  window.location.reload();
}

export function AppUpdatePrompt() {
  const updateAvailable = useAppUpdateCheck();
  const [showDialog, setShowDialog] = useState(true);

  if (!updateAvailable) {
    return null;
  }

  return (
    <>
      <Dialog
        hidden={!showDialog}
        onDismiss={() => setShowDialog(false)}
        minWidth={480}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Application updated',
          subText:
            'A new version of this application is available. Save any unsaved work or finish what you are doing, then refresh to load the latest version.',
        }}
        modalProps={{ isBlocking: true }}
      >
        <DialogFooter>
          <PrimaryButton text="Refresh now" onClick={reloadApp} />
          <DefaultButton text="I'll refresh later" onClick={() => setShowDialog(false)} />
        </DialogFooter>
      </Dialog>

      {!showDialog && (
        <Layer>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1000000,
            }}
          >
            <MessageBar
              messageBarType={MessageBarType.warning}
              isMultiline={false}
              actions={
                <div>
                  <PrimaryButton text="Refresh now" onClick={reloadApp} />
                </div>
              }
            >
              A new version is available. Save your work or finish what you are doing, then refresh.
            </MessageBar>
          </div>
        </Layer>
      )}
    </>
  );
}
